// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__RirD9","inputDescription":"styles_inputDescription__DV23S"};